// توليد رقم مرجعي موحّد لكل قيد: {PREFIX}-{YYYY-MM}-{ID}
// حسب قاعدة "الرقم المرجعي الموحّد للتطبيق" — لا ObjectId خام ولا شهر مجرّد.
const PREFIX = {
  payroll_accrual: "PAY", payroll_payment: "PPAY", payroll: "PAY",
  sales_commission: "SCOM", sales_invoice: "SI", invoice: "SI",
  reversal: "REV", opening: "OPN", disposal: "DISP",
  bonus: "BON", advance_to_debt: "ADV", impairment: "IMP",
  inventory_in: "INV-IN", inventory_out: "INV-OUT",
  lease_month: "LSE", eos_accrual: "EOS", transfer: "TRF",
  expense: "EXP", manual: "MNL", depreciation: "DEP",
  payment: "PMT", reconciliation: "REC",
  purchase_bill: "PB", bill: "PB", purchase_payment: "PP",
  receipt: "GR", supplier_payment: "SPY", customer_receipt: "CRC",
};

const isObjectId = (s) => typeof s === "string" && /^[a-f0-9]{24}$/i.test(s);
const isPeriod = (s) => typeof s === "string" && /^\d{4}-\d{2}$/.test(s);

export const refNumberFor = (entry) => {
  const src = entry?.source || "manual";
  const prefix = PREFIX[src] || src.slice(0, 3).toUpperCase();
  const raw = (entry?.source_ref || "").toString();

  // (1) رقم مرجعي قادم أصلاً بصيغة سليمة (يبدأ بحروف ثم شرطة) → استخدمه كما هو.
  if (raw && /^[A-Z]{2,}[-]/i.test(raw)) return raw.toUpperCase();

  // (2) فترة "YYYY-MM" → PREFIX-YYYY-MM
  if (isPeriod(raw)) return `${prefix}-${raw}`;

  // (3) "YYYY-MM:extra" → PREFIX-YYYY-MM
  if (raw.includes(":") && isPeriod(raw.split(":")[0])) return `${prefix}-${raw.split(":")[0]}`;

  // (4) ObjectId → PREFIX-YYYY-MM-XXXXXX (آخر 6 خانات)
  if (isObjectId(raw)) {
    const ym = (entry.date || "").slice(0, 7);
    return `${prefix}-${ym}-${raw.slice(-6).toUpperCase()}`;
  }

  // (5) لا مرجع → مشتق من رقم القيد JE-202608-00011 → PREFIX-2026-08-00011
  const m = /JE-(\d{4})(\d{2})-(\d+)/.exec(entry?.number || "");
  if (m) return `${prefix}-${m[1]}-${m[2]}-${m[3]}`;

  return `${prefix}-${(entry?.number || "").replace(/^JE-/i, "")}`;
};
